/**
 * @generated SignedSource<<1d9524463855d5ed064ae8a8043a9dab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Type = "PRAISE" | "REQUESTED" | "UNSOLICITED";
export type FeedbackItemQuery$variables = {
  id: string;
};
export type FeedbackItemQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly billingAccount: {
        readonly hasAccessToFeedback: boolean;
      };
    };
    readonly feedback: {
      readonly children?: ReadonlyArray<{
        readonly id: string;
        readonly requestCount: number;
        readonly responseCount: number;
        readonly threeSixtyRelation: number | null;
      }>;
      readonly createdAt?: string | null;
      readonly creator?: {
        readonly department: string | null;
        readonly email: string;
        readonly firstName: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
        readonly isGuest: boolean;
        readonly lastName: string;
        readonly title: string | null;
      } | null;
      readonly id?: string;
      readonly info?: any;
      readonly isAnonymous?: boolean;
      readonly isArchived?: boolean;
      readonly isDraft?: boolean;
      readonly isThreeSixtyParent?: boolean;
      readonly lastSeenByUser?: string | null;
      readonly questions?: any | null;
      readonly recipients?: ReadonlyArray<{
        readonly user: {
          readonly id: string;
        };
      }>;
      readonly recordList?: ReadonlyArray<{
        readonly contents: any | null;
      }>;
      readonly requests?: ReadonlyArray<{
        readonly feedbackRecord: {
          readonly contents: any | null;
          readonly createdAt: string | null;
          readonly id: string;
        } | null;
        readonly id: string;
        readonly user: {
          readonly email: string;
          readonly firstName: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly isGuest: boolean;
          readonly lastName: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"PersonRequest">;
      }>;
      readonly sharedWithMe?: boolean;
      readonly threeSixtyRelation?: number | null;
      readonly type?: Type;
      readonly " $fragmentSpreads": FragmentRefs<"FeedbackCardFeedback" | "FeedbackSubject_item" | "MoreActions_item" | "VisibilityBarFeedback">;
    } | null;
    readonly user: {
      readonly fullName: string;
      readonly id: string;
      readonly internalAttributes: {
        readonly directReports: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
            };
          }>;
        } | null;
        readonly manager: {
          readonly firstName: string;
          readonly fullName: string;
          readonly id: string;
        } | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"VisibilityBarUser">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"BillingIdentityFeaturesPaywall_viewer" | "NotFound_viewer" | "NoteAndFeedbackHistoryPaywall_viewer">;
  };
};
export type FeedbackItemQuery = {
  response: FeedbackItemQuery$data;
  variables: FeedbackItemQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "manager",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = [
  (v1/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "directReports",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v5/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": "hasAccessToFeedback",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "feedback"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"feedback\")"
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "info",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "questions",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sharedWithMe",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenByUser",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAnonymous",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isThreeSixtyParent",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "threeSixtyRelation",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestCount",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseCount",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "FeedbackNode",
  "kind": "LinkedField",
  "name": "children",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v19/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "department",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/)
  ],
  "storageKey": null
},
v30 = [
  {
    "kind": "Literal",
    "name": "recordType",
    "value": "DIRECT"
  }
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contents",
  "storageKey": null
},
v32 = [
  {
    "kind": "Literal",
    "name": "feature",
    "value": "history"
  }
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackItemQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VisibilityBarUser"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NoteAndFeedbackHistoryPaywall_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BillingIdentityFeaturesPaywall_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NotFound_viewer"
          },
          {
            "alias": "feedback",
            "args": (v8/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FeedbackCardFeedback"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FeedbackSubject_item"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MoreActions_item"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "VisibilityBarFeedback"
                  },
                  (v1/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v22/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeedbackRecipientNode",
                    "kind": "LinkedField",
                    "name": "recipients",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v30/*: any*/),
                    "concreteType": "FeedbackRecordNode",
                    "kind": "LinkedField",
                    "name": "recordList",
                    "plural": true,
                    "selections": [
                      (v31/*: any*/)
                    ],
                    "storageKey": "recordList(recordType:\"DIRECT\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeedbackRequestNode",
                    "kind": "LinkedField",
                    "name": "requests",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeedbackRecordNode",
                        "kind": "LinkedField",
                        "name": "feedbackRecord",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v1/*: any*/),
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v25/*: any*/),
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PersonRequest"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "FeedbackNode",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedbackItemQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v24/*: any*/),
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "restrictedMetrics",
                    "storageKey": null
                  },
                  {
                    "alias": "hasAccessToHistory",
                    "args": (v32/*: any*/),
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"history\")"
                  },
                  {
                    "alias": "historyLimit",
                    "args": (v32/*: any*/),
                    "kind": "ScalarField",
                    "name": "usageLimitForFeature",
                    "storageKey": "usageLimitForFeature(feature:\"history\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "featureAccess",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "feedback",
            "args": (v8/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v33/*: any*/),
              (v1/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  (v26/*: any*/),
                  (v11/*: any*/),
                  (v15/*: any*/),
                  (v17/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeedbackRecipientNode",
                    "kind": "LinkedField",
                    "name": "recipients",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          (v24/*: any*/),
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "shared",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "context",
                    "plural": true,
                    "selections": [
                      (v33/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v25/*: any*/),
                          (v28/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "relationshipToViewer",
                            "storageKey": null
                          }
                        ],
                        "type": "User",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "start",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "end",
                            "storageKey": null
                          }
                        ],
                        "type": "Event",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "eventStart",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "eventEnd",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          }
                        ],
                        "type": "Note",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "emoji",
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "type": "OtherContext",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v5/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMeetingFeedback",
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeedbackRequestNode",
                    "kind": "LinkedField",
                    "name": "requests",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeedbackRecordNode",
                        "kind": "LinkedField",
                        "name": "feedbackRecord",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v13/*: any*/),
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v25/*: any*/),
                          (v28/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeedbackNode",
                        "kind": "LinkedField",
                        "name": "feedback",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v19/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": (v30/*: any*/),
                    "concreteType": "FeedbackRecordNode",
                    "kind": "LinkedField",
                    "name": "recordList",
                    "plural": true,
                    "selections": [
                      (v31/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": "recordList(recordType:\"DIRECT\")"
                  }
                ],
                "type": "FeedbackNode",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d9cd30b149f8df6a9175fc00aba11b82",
    "id": null,
    "metadata": {},
    "name": "FeedbackItemQuery",
    "operationKind": "query",
    "text": "query FeedbackItemQuery(\n  $id: ID!\n) {\n  viewer {\n    user {\n      id\n      fullName\n      internalAttributes {\n        manager {\n          id\n          fullName\n          firstName\n        }\n        directReports {\n          edges {\n            node {\n              id\n            }\n          }\n        }\n        id\n      }\n      ...VisibilityBarUser\n    }\n    account {\n      billingAccount {\n        hasAccessToFeedback: hasAccessToFeature(feature: feedback)\n        id\n      }\n      id\n    }\n    ...NoteAndFeedbackHistoryPaywall_viewer\n    ...BillingIdentityFeaturesPaywall_viewer\n    ...NotFound_viewer\n    feedback: node(id: $id) {\n      __typename\n      ... on FeedbackNode {\n        ...FeedbackCardFeedback\n        ...FeedbackSubject_item\n        ...MoreActions_item\n        ...VisibilityBarFeedback\n        id\n        type\n        info\n        isDraft\n        isArchived\n        createdAt\n        questions\n        sharedWithMe\n        lastSeenByUser\n        isAnonymous\n        isThreeSixtyParent\n        threeSixtyRelation\n        children {\n          id\n          requestCount\n          responseCount\n          threeSixtyRelation\n        }\n        creator {\n          id\n          email\n          image\n          fullName\n          firstName\n          lastName\n          title\n          department\n          isGuest\n        }\n        recipients {\n          user {\n            id\n          }\n          id\n        }\n        recordList(recordType: DIRECT) {\n          contents\n          id\n        }\n        requests {\n          id\n          feedbackRecord {\n            createdAt\n            id\n            contents\n          }\n          user {\n            id\n            email\n            image\n            fullName\n            firstName\n            lastName\n            isGuest\n          }\n          ...PersonRequest\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment BillingIdentityFeaturesPaywall_viewer on Viewer {\n  account {\n    billingAccount {\n      featureAccess\n      id\n    }\n    id\n  }\n}\n\nfragment FeedbackCardFeedback on FeedbackNode {\n  ...FeedbackSubject_item\n  id\n  title\n  type\n  isArchived\n  isDraft\n  lastSeenByUser\n  isMeetingFeedback\n  requestCount\n  responseCount\n  sharedWithMe\n  updatedAt\n  isThreeSixtyParent\n  isAnonymous\n  creator {\n    id\n    email\n    image\n    fullName\n    firstName\n    lastName\n  }\n  recipients {\n    shared\n    user {\n      id\n    }\n    id\n  }\n}\n\nfragment FeedbackSubject_item on FeedbackNode {\n  id\n  type\n  title\n  isDraft\n  sharedWithMe\n  isAnonymous\n  creator {\n    id\n    email\n    image\n    fullName\n    firstName\n    lastName\n  }\n  recipients {\n    user {\n      id\n    }\n    id\n  }\n  context {\n    __typename\n    ... on User {\n      id\n      email\n      image\n      fullName\n      firstName\n      lastName\n      isGuest\n      relationshipToViewer\n    }\n    ... on Event {\n      id\n      title\n      start\n      end\n    }\n    ... on Note {\n      id\n      title\n      eventStart\n      eventEnd\n      url\n    }\n    ... on OtherContext {\n      name\n      emoji\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment MoreActions_item on FeedbackNode {\n  id\n  type\n  isDraft\n  sharedWithMe\n  isThreeSixtyParent\n  creator {\n    id\n  }\n  context {\n    __typename\n    ... on User {\n      id\n      fullName\n      firstName\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on OtherContext {\n      id\n    }\n  }\n  requests {\n    id\n    feedbackRecord {\n      id\n    }\n  }\n  recipients {\n    user {\n      id\n    }\n    id\n  }\n}\n\nfragment NotFound_viewer on Viewer {\n  ...BillingIdentityFeaturesPaywall_viewer\n}\n\nfragment NoteAndFeedbackHistoryPaywall_viewer on Viewer {\n  user {\n    isGuest\n    id\n  }\n  account {\n    billingAccount {\n      restrictedMetrics\n      hasAccessToHistory: hasAccessToFeature(feature: history)\n      historyLimit: usageLimitForFeature(feature: history)\n      id\n    }\n    id\n  }\n}\n\nfragment PersonRequest on FeedbackRequestNode {\n  id\n  feedback {\n    id\n    isAnonymous\n  }\n  feedbackRecord {\n    id\n    contents\n  }\n  user {\n    id\n    email\n    image\n    fullName\n    firstName\n    lastName\n    title\n    department\n    isGuest\n  }\n}\n\nfragment VisibilityBarFeedback on FeedbackNode {\n  isAnonymous\n  recipients {\n    user {\n      id\n      fullName\n      image\n      isGuest\n    }\n    id\n  }\n}\n\nfragment VisibilityBarUser on User {\n  id\n  fullName\n  image\n}\n"
  }
};
})();

(node as any).hash = "46cba77a3b54eca086314d1c7a72f4df";

export default node;
